import { useState } from 'react'
import { useStatsAllProjects } from '../../../hooks/useStatsAllProjects'
import { ProjectsTable } from './charts/ProjectsTable'
import { ProjectsTimelineChart } from './charts/ProjectsTimelineChart'

export const GeneralStatsPageAllProjects = () => {
  const { statsPerProject } = useStatsAllProjects()
  const [visibilityPerProject, setVisibilityPerProject] = useState<boolean[]>((statsPerProject ?? []).map((p) => true))
  // kept here, as the table should reflect the selected ones from the timeline chart.

  return (
    <>
      <div className="container">
        <div className="row" style={{ marginBottom: 40, marginTop: 40 }}>
          <div className="col-12">
            <h3>Randomizations</h3>
          </div>
          <div className="col-12">
            <ProjectsTimelineChart
              visibilityPerProject={visibilityPerProject}
              setVisibilityPerProject={setVisibilityPerProject}
            />
          </div>
          <div className="col-12 mt-5">
            <ProjectsTable visibilityPerProject={visibilityPerProject} />
          </div>
        </div>
      </div>
    </>
  )
}
